// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__tlD_K","tabsBox":"styles_tabsBox__2WefK","createButton":"styles_createButton__1CwRV"};